import React from "react";
import styled, { keyframes } from "styled-components";
import ChillTypeBeat from "../../../Assets/Audio/ChillTypeBeat.mp3";

const rotate = keyframes`
  0% { transform: rotate(270deg); }
  50% {     transform: scale(1.25);}
  100% { transform: rotate(360deg);}
`;

const Button = styled.button`
  z-index: 1;
  cursor: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg'  width='40' height='48' viewport='0 0 100 100' style='fill:black;font-size:24px;'><text y='50%'>🎧</text></svg>")
      16 0,
    auto;
  position: absolute;
  height: 37px;
  //   top: 5%;
  //   right: -0.5%;
  bottom: 175%;
  left: 50%;
  background: transparent;
  border: none;
  transform: translate(-50%, -50%);
`;
const Play = styled.div`
  box-sizing: border-box;
  border-style: solid;
  border-width: 20px 0px 20px 37px;
  border-color: transparent transparent transparent black;
  //   #40826d
  transition: all 0.3s ease-out;
  transform: rotate(270deg);
  animation: ${rotate} 2s linear 1.5s;
  -webkit-animation-fill-mode: forwards;
`;

const Pause = styled.div`
  width: 37px;
  height: 37px;
  box-sizing: border-box;
  border-color: transparent transparent transparent black;
  transition: all 0.3s ease-out;
  border-style: double;
  border-width: 0px 0px 0px 37px;
`;

const Music = () => {
  const [isPlaying, setIsPlaying] = React.useState(false);
  const [audio] = React.useState(
    typeof Audio !== "undefined" && new Audio(ChillTypeBeat)
  );
  React.useEffect(() => {
    isPlaying ? audio.play() : audio.pause();
    audio.loop = true;
  }, [isPlaying]);
  const handleClick = () => {
    setIsPlaying(!isPlaying);
  };

  return (
    <Button onClick={handleClick}>{isPlaying ? <Pause /> : <Play />}</Button>
  );
};
export default Music;
